module.exports = __webpack_public_path__ + "img/violet_029.909f380b.png";